var projectSettings = {
    inlineSVG: [
        '.group-header__logo img',
        '.group-footer__social-icons img',
        '.group-footer__panel-item-social img',
        '.group-footer__panel-item-image img',
        '.group-hotels__slider-img img',
        '.group-slider__scroll img',
        '.group-off-canvas__social-icons img',
        '.group-off-canvas__panel-item-social img',
        '.group-off-canvas__panel-item-image img',
    ]
}